import Image from 'next/image';
import CTA from 'react-scale/components/ui/cta';

const CardCTAs = ({ cards = [] }) => (
  <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
    {cards.map((card, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <CardCTA key={index} card={card} />
    ))}
  </div>
);

const CardCTA = ({ card }) => (
  <div className="border border-gray-700 rounded-lg bg-gray-900 flex flex-col">
    <div className="bg-black rounded-t-lg flex flex-col justify-center py-8 xl:py-10 items-center space-y-4">
      <Image
        src={card.img.src}
        layout="intrinsic"
        alt={card.img.alt}
        width={card.img.width}
        height={card.img.height}
        quality={100}
      />
      <p className="font-aeonik text-2xl xl:text-3xl leading-[48px]">{card.title}</p>
    </div>
    <div className="border-y border-gray-700 py-8 xl:py-10 text-center space-y-2 px-6 xl:px-8 flex-1">
      <p className="tracking-[4px] text-sm uppercase">IDEAL FOR</p>
      <p className="xl:text-lg leading-8">{card.body}</p>
    </div>
    <div className="py-10 px-10 flex justify-center">
      <CTA cta={card.cta} />
    </div>
  </div>
);

export default CardCTAs;
